module.exports = __webpack_public_path__ + "static/media/largeTarget.b9030c39.svg";